import React from 'react';

import { ChangelogTableAndFilters } from './commons/Changelog';
import { LPAccountFilters } from './LPAccountFilters';
import { Targets } from '../api/getChangelog';
import { dateFormatter } from '../helpers/cellsFormatter';
import { HeadCell } from '../types/changelog';
import {
  LPAccountsChangelog,
  LPAccountChangelogFormValues,
  SortableFields,
  initialFilters,
} from '../types/lp_accounts_changelog';
import { AccountEmailId } from './commons/Changelog/copyable-texts/AccountEmailId';
import { ChangedById } from './commons/Changelog/copyable-texts/ChangedById';

const headCells: HeadCell[] = [
  {
    id: 'created_at',
    path: 'changelog.created_at',
    label: 'Updated at',
    order: true,
    formatter: dateFormatter,
  },
  {
    id: 'changelog_item_type',
    path: 'changelog.changelog_item_type',
    label: 'Item Type',
  },
  {
    id: 'changelog_action',
    path: 'changelog.changelog_action',
    label: 'Action',
  },
  {
    id: 'lpaccount_email',
    path: 'changelog.lpaccount_email',
    label: 'Account Email / ID',
    render: (row) => {
      const { lpaccount_email, lpaccount_id } = (row as LPAccountsChangelog)
        .changelog;

      return <AccountEmailId email={lpaccount_email} id={lpaccount_id} />;
    },
  },
  {
    id: 'created_by_id',
    path: 'changelog.created_by_id',
    label: 'Changed by',
    render: (row) => (
      <ChangedById id={(row as LPAccountsChangelog).changelog.created_by_id} />
    ),
  },
];

export const LPAccount = () => (
  <ChangelogTableAndFilters<
    LPAccountsChangelog,
    LPAccountChangelogFormValues,
    SortableFields
  >
    title="LP Account"
    target={Targets.LPAccount}
    service="lpAccountV3"
    initialFilters={initialFilters}
    filtersComponent={LPAccountFilters}
    filtersAsDirectParams
    headCells={headCells}
  />
);
